var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.7144 20.4285L20.4286 25.1428L36.1429 9.42847","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M34.5714 22V33C34.5714 33.8336 34.2402 34.633 33.6508 35.2224C33.0614 35.8118 32.262 36.1429 31.4285 36.1429H9.4285C8.59496 36.1429 7.79557 35.8118 7.20617 35.2224C6.61677 34.633 6.28564 33.8336 6.28564 33V11C6.28564 10.1665 6.61677 9.3671 7.20617 8.7777C7.79557 8.1883 8.59496 7.85718 9.4285 7.85718H26.7142","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Checkmark.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
